module.exports = {"430511001":"新滩镇街道","430511002":"状元洲街道","430511003":"田江街道","430511004":"茶元头街道","430511203":"陈家桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430511.json
// module id = 1850
// module chunks = 0